import { autoInjectable } from 'tsyringe';
import { EpStore } from '../services/store/ep-store';
import { OverlayService } from '../services/overlay/overlay.service';
import { Analytics } from '../modules/analytics/analytics';
import { CommonEffect } from './common-effect';
import {of} from 'rxjs';

@autoInjectable()
export class PlacementEffects implements CommonEffect{

  constructor(private store?: EpStore,
              private overlayService?: OverlayService,
              private analytics?: Analytics){
  }

  bindSideEffects(){
    return of().subscribe();
  }
}
